import React, { FC, useEffect } from "react";
import { useWalletConnect } from "../services/WalletConnect/useWalletConnect";
import { useMetaMask } from "../services/MetaMask/useMetaMask";
import { Buffer } from "buffer";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { SolModalButton } from "./solana/SolModalButton";
import { SolWalletButton } from "./solana/SolWalletButton";
import { selectEVMAccount, selectSolAccount } from "../store/user/userSlice";

type Props = {
  show: boolean;
  onClose: () => void;
};

const center =
  "flex w-full flex-col justify-center items-center bg-neutral-900";

const bodyStyles = "flex flex-col w-full bg-neutral-900 rounded-md";

const titleStyles =
  "flex w-full flex-col items-start text-white m-2 text-2xl font3-bold";

const bodyRowStyles =
  "flex w-full flex-row justify-between items-center text-white pt-2 pl-4";

const leftBodyItem = "flex-grow flex justify-start items-center font3-bold";

const rightBodyItem = "mr-4";

const buttonStyles =
  "bg-blue-500 rounded-md pl-3 pr-3 pt-1 pb-1 shadow-lg hover:bg-blue-400 mb-2 text-white font3-bold";

const connectedButtonStyles =
  "bg-neutral-500 rounded-md pl-3 pr-3 pt-1 pb-1 mb-2 text-black font3";

const footerStyles = "m-2 mt-4";

const concatAddr = (addr: string) => {
  const strArr = addr.split("");
  const first = strArr.splice(0, 4);
  const last = strArr.splice(strArr.length - 5, 4);
  const returnedStr = first.join("") + "..." + last.join("");
  return returnedStr;
};

const ConnectModal: FC<Props> = (props) => {
  //this resolves a webpack 5 error in order to use walletconnect
  // @ts-ignore
  window.Buffer = Buffer;

  const solWallet = useAppSelector(selectSolAccount);
  const evmWallet = useAppSelector(selectEVMAccount);

  const dispatch = useAppDispatch();
  const wallConnFuncs = useWalletConnect();
  const metaMaskFuncs = useMetaMask();

  const handleWalletConnect = async () => {
    wallConnFuncs.start();
  };

  const handleMetaMask = async () => {
    const { address, chain } = await metaMaskFuncs.start();
    console.log(address);
  };

  const closeOnEscape = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      props.onClose();
    }
  };

  useEffect(() => {
    document.body.addEventListener("keydown", closeOnEscape);
    return function cleanup() {
      document.body.removeEventListener("keydown", closeOnEscape);
    };
  }, []);

  return (
    <div
      className={`modal ${props.show ? "show" : ""} ${center} rounded-lg`}
      onClick={props.onClose}
    >
      <div
        id="modal-content"
        className={`${center} rounded-lg`}
        onClick={(e) => e.stopPropagation()}
      >
        <div id="modal-header" className={`${center} rounded-md`}>
          <div className="flex flex-row w-full justify-evenly items-center pl-6 pr-6 h-[4rem]">
            <h1 id="modal-title" className={titleStyles}>
              Connect a wallet
            </h1>
            <button onClick={props.onClose} className="text-white">
              <img src="img/x.svg" height="25px" width="25px" className="invert"/>
            </button>
          </div>

          <div id="modal-body" className={bodyStyles}>
            <div className={bodyRowStyles}>
              <div className={leftBodyItem}>
                <img
                  src="../img/metamask-logo.png"
                  height="30px"
                  width="30px"
                  className="mr-2"
                />
                MetaMask
                <div className="text-gray-600 ml-2">
                  {evmWallet != "" ? "- " + concatAddr(evmWallet) : ""}
                </div>
              </div>
              <div className={rightBodyItem}>
                {evmWallet === "" ? (
                  <button className={buttonStyles} onClick={handleMetaMask}>
                    Connect
                  </button>
                ) : (
                  <button className={connectedButtonStyles} disabled={true}>
                    Connected
                  </button>
                )}
              </div>
            </div>

            <div className={bodyRowStyles}>
              <div className={leftBodyItem}>
                <img
                  src="../img/walletconnect-logo.png"
                  height="30px"
                  width="30px"
                  className="mr-2"
                />
                WalletConnect
              </div>
              <div className={rightBodyItem}>
                <button className={buttonStyles} onClick={handleWalletConnect}>
                  Connect
                </button>
              </div>
            </div>
            <div className={bodyRowStyles}>
              <div className={leftBodyItem}>
                <img
                  src="../img/solana-icon.webp"
                  height="30px"
                  width="30px"
                  className="mr-2"
                />
                Solana
                <div className="text-gray-600 ml-2">
                  {solWallet != "" ? "- " + concatAddr(solWallet) : ""}
                </div>
              </div>
              <div className={rightBodyItem}>
                {solWallet === "" ? <SolModalButton /> : <SolWalletButton />}
              </div>
            </div>
          </div>
          {/* <div id="modal-footer" className={footerStyles}>
            <button onClick={props.onClose} className={buttonStyles}>
              Close
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ConnectModal;
